function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiftUiLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 4.769531 37.5 C 3.519531 37.5 2.5 36.480469 2.5 35.230469 L 2.5 4.769531 C 2.5 3.519531 3.519531 2.5 4.769531 2.5 L 35.230469 2.5 C 36.480469 2.5 37.5 3.519531 37.5 4.769531 L 37.5 35.230469 C 37.5 36.480469 36.480469 37.5 35.230469 37.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 35.230469 3 C 36.207031 3 37 3.792969 37 4.769531 L 37 35.230469 C 37 36.207031 36.207031 37 35.230469 37 L 4.769531 37 C 3.792969 37 3 36.207031 3 35.230469 L 3 4.769531 C 3 3.792969 3.792969 3 4.769531 3 L 35.230469 3 M 35.230469 2 L 4.769531 2 C 3.238281 2 2 3.238281 2 4.769531 L 2 35.230469 C 2 36.761719 3.238281 38 4.769531 38 L 35.230469 38 C 36.761719 38 38 36.761719 38 35.230469 L 38 4.769531 C 38 3.238281 36.761719 2 35.230469 2 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 25.613281 25.847656 C 34.460938 16.996094 21 6 21 6 L 18 3 L 4.769531 3 C 3.792969 3 3 3.792969 3 4.769531 L 3 20 L 5 22 C 5 22 16.769531 34.695313 25.613281 25.847656 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 21 6 C 28.160156 10.691406 30 14.988281 30 19 C 30 21.007813 29 22.902344 29 22.902344 C 29 22.902344 32.394531 26.453125 30.335938 30 C 30.335938 30 29.246094 27 27 27 C 24.835938 27 23.601563 30 19.242188 30 C 9.535156 30 5 22 5 22 C 14.375 28.042969 19.589844 23.078125 19.589844 23.078125 C 12.722656 17.921875 7 9 7 9 C 14.300781 15.15625 18 18 18 18 C 16.117188 16.457031 10 8 10 8 C 14.222656 12.238281 23.394531 18.921875 23.394531 18.921875 C 25.585938 13.417969 21 6 21 6 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftUiLogo);
export default __webpack_public_path__ + "static/media/swiftUiLogo.2becdf59b5e3fa06152adb90ec575a5e.svg";
export { ForwardRef as ReactComponent };